<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  icon: string;
}>();

const iconUrl = computed(
  () => `${window.location.origin}/tokens/assets/icons/sprite.svg#${props.icon}`,
);
</script>

<template>
  <svg fill="currentColor" width="24" height="24">
    <use :xlink:href="iconUrl" />
  </svg>
</template>
